export function undefined(d){
    return typeof d === 'undefined';
}